import { jsx as i, jsxs as l } from "react/jsx-runtime";
import { CurrencyBadge as d } from "../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as f } from "../../utils/get-amount-with-currency-symbol.mjs";
import { centsToUnits as b, useTranslation as v } from "@systemeio/ui";
import { PricePlanTypeEnum as u } from "../../libs/types/dist/index9.mjs";
import { Trans as s } from "react-i18next";
import { useLocaleContext as h } from "../../providers/use-locale-provider.mjs";
const c = ({ children: n }) => /* @__PURE__ */ i("span", { className: "font-semibold", children: n }), T = ({ type: n, amount: t, currency: e, recurringOptions: o }) => {
  if (n === u.one_shot)
    return /* @__PURE__ */ i(P, { amount: t, currency: e });
  if (n === u.subscription)
    return /* @__PURE__ */ i(
      x,
      {
        amount: t,
        currency: e,
        recurringOptions: o
      }
    );
  if (n === u.limited_subscription)
    return /* @__PURE__ */ i(
      y,
      {
        amount: t,
        currency: e,
        recurringOptions: o
      }
    );
}, P = ({
  amount: n,
  currency: t
}) => {
  const { locale: e } = h(), o = f(
    b(n),
    t,
    e
  );
  return /* @__PURE__ */ l("div", { className: "flex items-center", children: [
    /* @__PURE__ */ i(d, { currency: t }),
    /* @__PURE__ */ i("div", { className: "ml-1 text-[14px] font-semibold", children: o })
  ] });
}, x = ({
  amount: n,
  currency: t,
  recurringOptions: e
}) => {
  const { locale: o } = h(), { t: r, i18n: a } = v(), p = f(
    b(n),
    t,
    o
  ), m = e.trialPeriod ? /* @__PURE__ */ i(
    s,
    {
      i18n: a,
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.trial_period_new",
      values: {
        trialPeriodPrice: r(
          "public_pages_purchase.components.offer_price.price_plans.trial_period_price"
        ),
        trialInterval: r(
          `public_pages_purchase.price_plan.trial_period.${e.trialInterval}`,
          {
            count: e.trialPeriod
          }
        )
      },
      components: {
        b: /* @__PURE__ */ i(c, {})
      }
    }
  ) : void 0, _ = /* @__PURE__ */ i(
    s,
    {
      i18n: a,
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.unlimited_new",
      values: {
        amount: p,
        interval: r(`public_pages_purchase.price_plan.interval.${e.interval}`, {
          count: e.intervalCount
        })
      },
      components: {
        b: /* @__PURE__ */ i(c, {})
      }
    }
  );
  return /* @__PURE__ */ l("div", { className: "flex items-center", children: [
    /* @__PURE__ */ i(d, { currency: t }),
    /* @__PURE__ */ l("div", { className: "ml-3 text-right", children: [
      m,
      /* @__PURE__ */ i("br", {}),
      _
    ] })
  ] });
}, y = ({
  amount: n,
  currency: t,
  recurringOptions: e
}) => {
  const { locale: o } = h(), { t: r, i18n: a } = v(), p = f(
    b(n),
    t,
    o
  ), m = e.trialPeriod ? /* @__PURE__ */ i(
    s,
    {
      i18n: a,
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.trial_period_new",
      values: {
        trialPeriodPrice: r(
          "public_pages_purchase.components.offer_price.price_plans.trial_period_price"
        ),
        trialInterval: r(
          `public_pages_purchase.price_plan.trial_period.${e.trialInterval}`,
          {
            count: e.trialPeriod
          }
        )
      },
      components: {
        b: /* @__PURE__ */ i(c, {})
      }
    }
  ) : void 0, _ = /* @__PURE__ */ i(
    s,
    {
      i18n: a,
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.limited_with_limit_of_payments",
      values: {
        amount: p,
        count: e.limitOfPayments,
        interval: r(`public_pages_purchase.price_plan.interval.${e.interval}`, {
          count: e.intervalCount
        })
      },
      components: {
        b: /* @__PURE__ */ i(c, {})
      }
    }
  );
  return /* @__PURE__ */ l("div", { className: "flex items-center", children: [
    /* @__PURE__ */ i(d, { currency: t }),
    /* @__PURE__ */ l("div", { className: "ml-3 text-right", children: [
      m,
      /* @__PURE__ */ i("br", {}),
      _
    ] })
  ] });
};
export {
  y as PricePlanLimitedSubscriptionInfo,
  P as PricePlanOneShotInfo,
  x as PricePlanSubscriptionInfo,
  T as default
};
